import { Link } from 'react-router-dom';
import type { Video } from '@/types/video';
import { getCategoryMeta } from '@/types/video';
import { formatViews } from '@/lib/videoData';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  const meta = getCategoryMeta(video.category);

  return (
    <Link
      to={`/detail/${video.id}`}
      data-product-shop
      className="group block overflow-hidden rounded-lg border border-background-800/80 bg-background-900 transition-colors hover:border-primary-500/70"
    >
      <div className="poster-zoom relative aspect-[3/4] w-full overflow-hidden bg-background-800">
        <img
          src={video.cover}
          alt={`${video.title}封面`}
          title={`${video.title} - 桃子视频`}
          className="h-full w-full object-cover object-top"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50">
          {meta?.name}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-background-950/75 px-2 py-0.5 text-xs font-semibold text-primary-300">
          <i className="ri-star-fill text-[11px]" />
          {video.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-center gap-1 bg-gradient-to-t from-background-950/90 to-transparent px-2 pb-2 pt-8 text-xs text-foreground-300">
          <i className="ri-fire-line text-primary-400" />
          <span>{formatViews(video.views)}次播放</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-50 transition-colors group-hover:text-primary-400">
          {video.title}
        </h3>
        <div className="mt-1.5 flex items-center justify-between text-xs text-foreground-400">
          <span className="truncate">
            {video.region} · {video.year}
          </span>
          <span className="whitespace-nowrap">{video.updateDate}</span>
        </div>
      </div>
    </Link>
  );
}